import "./App.scss"
import { Routes, Route,Navigate} from "react-router-dom"
import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import Home from "./screens/Home"
import Cab from "./screens/Cab"
import Partner from "./screens/PartnerNew"
import Corporate from "./screens/Corporate"
import AboutUs from "./screens/AboutUs"
import Blogs from "./screens/Blogs"
import GetApp from "./screens/GetApp"
import BookCab from "./screens/BookCab"
import PrivacyPolicy from "./screens/PrivacyPolicy"
import RefundAndCancellation from "./screens/RefundAndCancellation"
import TermsAndConditions from "./screens/TermsAndConditions"
import Cities from "./screens/Cities"
import CityPairPage from "./screens/CityPair"
import BookingSuccess from "./screens/BookingSuccess"

import BlogPageGem from "./screens/Blogs/BlogPageGem"
import NotFound from "./screens/NotFound"
import SessionExpiryListener from "./components/SessionExpiryListener"
import WhatsAppFloat from "./components/WhatsAppFloat"
import ChatNudge from "./components/ChatNudge"

import { getUserLocation } from "./store/UserLocation/UserLocationAction"
import { getDynamicHeaderImage } from "./store/DynamicData/DynamicDataAction"
import { loadGoogleMaps } from "./utils/loadGoogleMaps"
import { captureAttribution } from "./utils/attribution"
import { loadGoogleAds } from "./utils/googleAds"
import CabEstimatePage from "./screens/CabEstimatePage"
import FindVehicle from "./screens/FindVehicle"
import GstInvoiceGuide from "./screens/GstInvoiceGuide"
import PartnerOnboarding from "./screens/PartnerOnboarding"

// Start loading Google Maps immediately at module level (before any component renders)
loadGoogleMaps()

// Capture the ad click at module level too — the gclid is only on the landing
// URL, and a router navigation would erase it before any component mounts.
captureAttribution()

function App() {
  const dispatch = useDispatch()
  const { location } = useSelector((state) => state.location)

  // Get user location
  useEffect(() => {
    dispatch(getUserLocation({}))
  }, [dispatch])

  // Load dynamic header image
  useEffect(() => {
    if (location?.city) {
      dispatch(getDynamicHeaderImage({ city: location.city }))
    }
  }, [dispatch, location?.city])

  // Load Google Maps asynchronously in the background (non-blocking)
  useEffect(() => {
    loadGoogleMaps().catch(() => {
      // Silently catch errors - don't block the app or show errors
    })
  }, [])

  // Google Ads — single loader, ID from .env (see utils/googleAds.js)
  useEffect(() => {
    loadGoogleAds()
  }, [])

  return (
    <div>
      <SessionExpiryListener />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cabs" element={<Cab />} />
        <Route path="/bookCab" element={<BookCab />} />

        <Route path="/cab-driver-registration" element={<Partner />} />
        <Route path="/cab-driver-registration/onboarding" element={<PartnerOnboarding />} />
        <Route path="/partner" element={<Navigate to="/cab-driver-registration" replace />} />
        <Route path="/partner-new" element={<Navigate to="/cab-driver-registration" replace />} />
        <Route path="/corporate-cab-services" element={<Corporate />} />
        <Route path="/gst-invoice-for-cab-bookings" element={<GstInvoiceGuide />} />
        <Route path="/corporate" element={<Navigate to="/corporate-cab-services" replace />} />
        <Route path="/business" element={<Navigate to="/corporate-cab-services" replace />} />


        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:slug" element={<BlogPageGem />} />
        <Route path="/get-app" element={<GetApp />} />

        {/* policies */}
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        <Route path="/terms_condition" element={<TermsAndConditions />} />
        <Route path="/refund-cancellation" element={<RefundAndCancellation />} />


        <Route path="/cab/:uniqueId" element={<CabEstimatePage />} />

        <Route path="/find-vehicle" element={<FindVehicle />} />


        {/* SEO pages */}
        <Route path="/cities/:cityName" element={<Cities />} />
        {/* Public SEO landing pages — must render for anonymous visitors and crawlers.
            Session gating happens at booking actions, never on page view. */}
        <Route path="/routes/:routePath" element={<CityPairPage />} />
                {/* Booking Success — dynamic slug prevents direct guessing */}
        <Route path="/booking-success/:routeSlug" element={<BookingSuccess />} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <WhatsAppFloat />
      <ChatNudge />
    </div>
  )
}

export default App
